import { Pagination, Navigation, Autoplay } from 'swiper/modules';

export default function () {
    window.addEventListener('load', () => {
        const anySwiper = document.querySelector('.swiper:not(.product-images)');

        if (!anySwiper) return;

        import('swiper').then((module) => {
            const Swiper = module.default;
            const cs = getComputedStyle(document.documentElement);

            //MAIN BANNER
            const mainBanner = new Swiper('.main-banner', {
                modules: [Pagination, Autoplay],
                preloadImages: false,
                autoplay: {
                    delay: 4000
                },
                lazy: true,
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true
                },
                on: {
                    beforeTransitionStart: function (instance) {
                        const currentSlide = instance.slides[instance.activeIndex];
                        const slideImg = currentSlide.querySelector('img');
                        
                        if (slideImg.hasAttribute('src')) return;

                        currentSlide.classList.add('loaded');
                        slideImg.setAttribute('src', slideImg.getAttribute('data-src'));
                    }
                }
            });

            //MAIN PAGE PRODUCTS
            const breakpoints = {
                1: {},
                375: {},
                601: {},
                1100: {},
                1280: {}
            };

            const slider1 = new Swiper('.slider-with-products.slider-promoPromoted .swiper', {
                modules: [Navigation],
                preloadImages: false,
                navigation: {
                    nextEl: '.swiper-button-next.slider-button-promoPromoted',
                    prevEl: '.swiper-button-prev.slider-button-promoPromoted'
                },
                loop: false,
                breakpoints: breakpoints,
                slidesPerView: Number(cs.getPropertyValue('--prodSwiperCols')),
                spaceBetween: Number(cs.getPropertyValue('--prodGapSwiper').replace('px', '')),

            });

            slider1.on('breakpoint', function () {
                slider1.params.slidesPerView = Number(cs.getPropertyValue('--prodSwiperCols'));
                slider1.params.spaceBetween = Number(cs.getPropertyValue('--prodGapSwiper').replace('px', ''));
                slider1.update();
            });

            const slider3 = new Swiper('.slider-with-products.slider-promoBestseller .swiper', {
                modules: [Navigation],
                preloadImages: false,
                navigation: {
                    nextEl: '.swiper-button-next.slider-button-promoBestseller',
                    prevEl: '.swiper-button-prev.slider-button-promoBestseller'
                },
                loop: false,
                breakpoints: breakpoints,
                slidesPerView: Number(cs.getPropertyValue('--prodSwiperCols')),
                spaceBetween: Number(cs.getPropertyValue('--prodGapSwiper').replace('px', '')),

            });

            slider3.on('breakpoint', function () {
                slider3.params.slidesPerView = Number(cs.getPropertyValue('--prodSwiperCols'));
                slider3.params.spaceBetween = Number(cs.getPropertyValue('--prodGapSwiper').replace('px', ''));
                slider3.update();
            });





            const slider2 = new Swiper('.slider-with-products.slider-promoNew .swiper', {
                modules: [Navigation],
                preloadImages: false,
                navigation: {
                    nextEl: '.swiper-button-next.slider-button-promoNew',
                    prevEl: '.swiper-button-prev.slider-button-promoNew'
                },
                loop: true,
            });


            //PRODUCERS
            const producersBanner = new Swiper('.producers-banner .swiper', {
                modules: [Navigation],
                preloadImages: false,
                navigation: {
                    nextEl: '.swiper-button-next.producer-button',
                    prevEl: '.swiper-button-prev.producer-button'
                },
                loop: false,
                spaceBetween: 61,
                breakpoints: {
                    1: {
                        slidesPerView: 3,
                        spaceBetween: 15
                    },
                    601: {
                        slidesPerView: 3
                    },
                    1100: {
                        slidesPerView: 4
                    },
                    1280: {
                        slidesPerView: 5
                    },
                    1681: {
                        slidesPerView: 6
                    }
                }
            });
        });
    }, false);
}